import { Box, Breadcrumbs, Link, Stack, SxProps } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useBreakpoints from '../../../hooks/useBreakpoint';
import { ceraProBold, defaultBorder, vars } from '../../../Theme';
import i18n from '../../../localization/i18n';

/** Collection of footer URLs in all supported application languages. */
const urls = {
    legal: {
        de: 'https://www.eplass.de/allgemein/impressum.html',
        en: 'https://www.eplass.com/general/legal-info.html',
    },
    terms: {
        de: 'https://www.eplass.de/allgemein/allgemeine-geschaeftsbedingungen.html',
        en: 'https://www.eplass.com/general/terms-of-contract.html',
    },
    privacy: {
        de: 'https://www.eplass.de/allgemein/datenschutz.html',
        en: 'https://www.eplass.com/general/privacy-statement.html',
    },
};

/**
 * Helper component for creating footer link elements.
 */
const FooterLink = (props: { text: string; url: string }) => (
    <Link href={props.url} color='inherit' underline='none' target='_blank'>
        {props.text}
    </Link>
);

/** Footer font styles. */
const fontSx: SxProps = {
    color: vars.font,
    ...ceraProBold,
    fontSize: 12,
};

/**
 * Application Footer (shows legal information, etc.).
 */
export default () => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'footer' });

    /** Determine screen size. */
    const { isDesktop } = useBreakpoints();

    /** Create the Footer Link elements. */
    const links = Object.keys(urls).map((key: string) => {
        /** Use the english URL as a fallback. */
        const url = urls[key][i18n.language] ?? urls[key].en;

        return <FooterLink key={key} url={url} text={t(key)} />;
    });

    return (
        <Stack
            direction='row'
            alignItems='center'
            sx={{ borderTop: defaultBorder, px: isDesktop ? 4.5 : 2, height: 30 }}
        >
            <Box flexGrow={4} sx={{ ...fontSx }}>
                &copy; {new Date().getFullYear()} Thinkproject
            </Box>

            <Breadcrumbs separator='|' sx={{ ...fontSx }}>
                {links}
            </Breadcrumbs>
        </Stack>
    );
};
